export const INSUFFICIENT_PERMISSIONS_TOOLTIP = "You do not have permission to perform this action."

export const permissionTooltip = (hasPermission: boolean | undefined) =>
	!hasPermission ? INSUFFICIENT_PERMISSIONS_TOOLTIP : ""
